<form id="customerForm" role="form" class="wizardcustomerForm form-horizontal" [formGroup]="form">
  <div class="row">
    <div class="col-md-3">
      @if (currentCustomer) {
        <div class="pull-left" style="margin-bottom: 10px;">
          @if ('task.change'|HasPerm) {
            <button class="btn btn-success"
                    [disabled]="!!currentCustomer.locked"
                    [title]="(!!currentCustomer.locked ? 'Kunde gesperrt - es kann kein neuer Vorgang erstellt werden' : '')"
              (click)="finishEmitter.emit({typ: 1, customerId: currentCustomer.id, contactId: $safeNavigationMigration(currentContact?.id)})"
              type="button"
              >
              Neuer Auftrag
            </button>
          }
          &nbsp;
          @if ('task.offer.change'|HasPerm) {
            <button class="btn btn-success"
                    [disabled]="!!currentCustomer.locked"
                    [title]="(!!currentCustomer.locked ? 'Kunde gesperrt - es kann kein neuer Vorgang erstellt werden' : '')"
              (click)="finishEmitter.emit({typ: 0, customerId: currentCustomer.id, contactId: $safeNavigationMigration(currentContact?.id)})"
              type="button"
              >
              Neues Angebot
            </button>
          }
        </div>
      }
    </div>
    <div class="col-md-2">
      @if (currentCustomer) {
        <button class="btn btn-success" (click)="newContact()">
          Neuer Ansprechpartner erstellen
        </button>
      }
    </div>
  </div>

  <div class="row">
    <div class="col-sm-3">
      <div class="row">
        <div class="col-sm-2"><h3><label for="id_oa_nr">Kunde</label></h3></div>
        <div class="col-sm-9">
          <input class="form-control" id="id_oa_nr" type="text" formControlName="search" [autofocus]>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="whitelist whitelist-bold-head">
            @for (customer of customerList?.objects; track customer) {
              <div class="whitelist-item"
                [ngClass]="{selected: currentCustomer?.id === customer.id}"
                (click)="selectCustomer(customer)">
                <h4>
                  {{ customer.name }}
                  @if (customer.locked) {
                    <span class="label label-warning">Gesperrt</span>
                  }
                </h4>
                <p>{{ customer.street }}</p>
                <p>{{ customer.country }} - {{ customer.zip }} {{ customer.city }}</p>
              </div>
            }
          </div>

          <nav>
            <button type="button" class="btn btn-default pull-left"
              (click)="setPage($safeNavigationMigration(customerList?.page) - 1)"
              [disabled]="$safeNavigationMigration(customerList?.page) <= 1">
              Zurück
            </button>

            <button type="button" class="btn btn-default pull-right"
              (click)="setPage($safeNavigationMigration(customerList?.page) + 1)"
              [disabled]="customerList?.page === customerList?.pages">
              Weiter
            </button>
          </nav>

        </div>
      </div>
    </div>
    <div class="col-sm-3">
      <div class="row">
        <div class="col-sm-12">
          <h3>Ansprechpartner</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="whitelist whitelist-one-row">
            @if (contactList) {
              <div class="whitelist-item nocontact-row"
                (click)="selectContact(null)"
                [ngClass]="{selected: !currentContact}">
                <h4>Kein Ansprechpartner</h4>
              </div>
            }
            @for (contact of contactList; track contact) {
              <div class="whitelist-item contact-row"
                [ngClass]="{selected: contact.id === currentContact?.id}"
                (click)="selectContact(contact)">
                <p>{{ contact.title }}</p>
                <h4>{{ contact.last_name }}, {{ contact.first_name }} </h4>
                <p>{{ contact.position }}</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      @if (currentCustomer?.sales_note) {
        <div class="row sales-note-box-danger">
          <div class="col-sm-12">
            <h3>Angebotsrelevante Informationen</h3>
          </div>
          <div class="col-sm-12">
            <pre id="sales_note">{{ currentCustomer.sales_note }}</pre>
          </div>
        </div>
      }
      @if (currentCustomer?.note) {
        <div class="row sales-note-box-warning">
          <div class="col-sm-12">
            <h3>Allgemeine Notiz</h3>
          </div>
          <div class="col-sm-12">
            <pre id="note">{{ currentCustomer.note }}</pre>
          </div>
        </div>
      }
    </div>
  </div>

</form>
